import { BaseSyntheticEvent } from 'react';
import { Control } from 'react-hook-form';
import { z } from 'zod';

export type DeliveryFrequencyV2Props = {
  label?: string;
  isOpen: boolean;
  onClose: () => void;
  intervals: string;
  unit: string;
  currentInterval: string;
  referenceId?: number; // contractId passed in as prop rather than fetched from page ID
  isUnifiedCheckout?: boolean;
  setNewDateValue?: React.Dispatch<React.SetStateAction<number>>;
};

export type DeliveryFrequencyViewProps = {
  isLoadingStatus: boolean;
  handleSubmitInternal: (e?: BaseSyntheticEvent<object, any, any> | undefined) => Promise<void>;
  intervalFrequencyList: string[];
  control: Control<
    {
      deliveryOptions: string;
    },
    any
  >;
  isSubmitting: boolean;
  isDisabled: boolean;
  frequencyUnit: string;
  currentInterval: number;
  newDateValue: number | undefined;
};

export type DeliveryFrequencyDatePickerProps = {
  referenceId: number | undefined; // contractId passed in as prop rather than fetched from page ID
  newDateValue: number | undefined;
  setNewDateValue: React.Dispatch<React.SetStateAction<number>> | undefined;
  option: number;
  onClose: () => void;
};

export type DeliveryFrequencyInfoProps = {
  newDateValue: number | undefined;
  option: string;
  handleClick?: () => void;
  showExtraInfo?: boolean;
  className?: string;
};

export const stepSchema = z.enum(['frequency', 'calendar']);

export type Step = z.infer<typeof stepSchema>;
